import { createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"invitation-wrap my-5\"><div class=\"card text-center\"><div class=\"error-media-holder shadowed-card\"><img src=\"img/page-not-found.svg\"></div><hr><div class=\"card-head\"><h1 class=\"card-title\">Whoops... this page is not available.</h1></div><div class=\"text-center inner-wrap pb-0\"><a href=\"#/dashboard\" class=\"btn default-btn outline\"> Go back to Dashboard</a></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
}